<script>
import messages from '../de/messages.vue';
import labels from '../de/labels.vue';
import text from '../de/text.vue';
import app from '../de/app.vue';


export default 
  {
    messages: messages,
    labels: labels,
    text: text,
    app: app
  }
</script>
